import * as yup from 'yup'

export class VehicleExporterPhotosDto {
  manufacturerLabelImageExporterFileName?: string = undefined
  tpmsTelltaleImageExporterFileName?: string = undefined
  odometerImageExporterFileName?: string = undefined
  manufacturerLabelImageExporterFile?: File = undefined
  tpmsTelltaleImageExporterFile?: File = undefined
  odometerImageExporterFile?: File = undefined
}

export const vehicleExporterPhotoValidationSchema = yup.object({
  manufacturerLabelImageExporterFile: yup
    .mixed()
    //@ts-ignore
    .test('Manufacturer Label Image is required.', (value: File) => value)
    .required('Manufacturer Label Image is required.'),
  tpmsTelltaleImageExporterFile: yup
    .mixed()
    //@ts-ignore
    .test('TPMS Telltale Label Image is required.', (value: File) => value)
    .required('TPMS Telltale Label Image is required.'),
  odometerImageExporterFile: yup
    .mixed()
    //@ts-ignore
    .test('Odometer Label Image is required.', (value: File) => value)
    .required('Odometer Label Image is required.')
})
